import { Menu } from "antd";
import { darken } from "polished";
import styled from "styled-components";

export const StyledVerticalNav = styled(Menu)`
  padding-bottom: 8px;
  height: calc(100% - 25px);
  overflow-y: auto;
  overflow-x: hidden;

  // media query for mobile
  @media (max-width: 768px) {
    height: calc(100% - 22px);
  }

  &.ant-menu {
    background: inherit !important;
    padding-top: 15px !important;

    &.ant-menu-inline-collapsed {
      .ant-menu-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        > :not(.ant-menu-item-icon) {
          display: none !important;
        }
      }
      .ant-menu-submenu-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        > :not(.ant-menu-item-icon) {
          display: none !important;
        }
      }

      .ant-menu-item-group {
        .ant-menu-item-group-title {
          padding: 0 3px !important;

          span {
            display: none !important;
          }

          &:after {
            content: "";
            width: 100%;
            height: 2px;
            background-color: ${({ theme }) =>
              theme.palette.text.disabled}!important;
            display: block !important;
          }
        }
      }
    }

    .ant-menu-item-group {
      margin-top: 20px;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .ant-menu {
        width: 100% !important;
      }

      .ant-menu-item-group-title {
        padding: 0px 16px !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.05em !important;
        color: ${({ theme }) => theme.palette.text.primary}!important;

        span {
          position: relative;
          padding-right: 16px !important;

          // divider line
          &:after {
            content: "";
            position: absolute;
            left: 100%;
            top: 50%;
            width: calc(100vw - 100%);
            height: 1px;
            background-color: ${({ theme }) =>
              theme.palette.text.disabled}!important;
            transform: translateY(-50%);
            z-index: 1;
          }
        }
      }

      .ant-menu-item-group-list {
        margin-top: 0px !important;

        .ant-menu-item {
          height: 25px !important;
          width: 100% !important;
          margin: 0 !important;
          border-radius: 0 !important;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background-color: transparent !important;
          position: relative;
          overflow: hidden;

          display: flex;
          align-items: center;

          .ant-menu-item-icon {
            height: 100% !important;
          }

          // Hover effect with smooth background transition
          &:hover {
            background-color: ${({ theme }) =>
              darken(0.02, theme.palette.background.secondary)}!important;
            transform: translateX(2px);

            // Subtle left border animation
            &:before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 3px;
              height: 100%;
              background-color: ${({ theme }) =>
                darken(0.02, theme.palette.primary.main)};
              transform: scaleY(0);
              animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
            }
          }

          // Active state when clicking
          &:active {
            background-color: ${({ theme }) =>
              darken(0.08, theme.palette.background.secondary)}!important;
            transform: translateX(1px);
            transition: all 0.1s ease;
          }

          // Focus state for accessibility
          &:focus-visible {
            outline: 2px solid ${({ theme }) => theme.palette.primary.main};
            outline-offset: -2px;
          }

          &.ant-menu-item-active {
            background-color: ${({ theme }) =>
              darken(0.05, theme.palette.background.secondary)}!important;
          }

          &.ant-menu-item-selected {
            background-color: ${({ theme }) =>
              theme.palette.background.secondary}!important;
            transform: translateX(2px);

            .ant-menu-item-icon {
              color: ${({ theme }) => theme.palette.text.primary}!important;
            }

            // Subtle left border animation
            &:before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 3px;
              height: 100%;
              background-color: ${({ theme }) => theme.palette.primary.main};
              transform: scaleY(0);
              animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
            }
          }
        }

        .ant-menu-submenu {
          margin-top: 3px !important;

          margin: 0 !important;
          border-radius: 0 !important;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;

          &.ant-menu-submenu-selected {
            background-color: ${({ theme }) =>
              theme.palette.background.secondary}!important;
          }

          .ant-menu-submenu-title {
            height: 25px !important;
            width: 100% !important;
            // padding-inline: 16px !important;
            margin: 0 !important;
            border-radius: 0 !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;

            // Hover effect for submenu titles
            &:hover {
              background-color: ${({ theme }) =>
                darken(0.02, theme.palette.background.secondary)}!important;
              transform: translateX(2px);

              &:before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 3px;
                height: 100%;
                background-color: ${({ theme }) => theme.palette.primary.main};
                transform: scaleY(0);
                animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
              }
            }

            // Active state for submenu titles
            &:active {
              background-color: ${({ theme }) =>
                darken(0.08, theme.palette.background.secondary)}!important;
              transform: translateX(1px);
              transition: all 0.1s ease;
            }

            // Focus state for accessibility
            &:focus-visible {
              outline: 2px solid ${({ theme }) => theme.palette.primary.main};
              outline-offset: -2px;
            }
          }

          &.ant-menu-submenu-open {
            background-color: ${({ theme }) =>
              theme.palette.background.secondary}!important;
          }
        }
      }
    }
  }

  // Keyframe animation for left border slide-in effect
  @keyframes slideIn {
    from {
      transform: scaleY(0);
    }
    to {
      transform: scaleY(1);
    }
  }
`;
